import { useState } from 'react';
import { MainLayout } from '@/components/layout/MainLayout';
import { JobForm } from '@/components/jobs/JobForm';
import { useNavigate } from 'react-router-dom';
import { createJob } from '@/lib/api/jobs';
import { jobPath } from '@/lib/utils/navPaths';

export const JobCreatePage = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (formData: Record<string, unknown>) => {
    setSubmitting(true);
    setSubmitError('');
    try {
      const response = await createJob(formData);
      navigate(jobPath(formData.client_id as string | undefined, (response.job_id ?? response.id) as number));
    } catch (error) {
      console.error('Failed to create job:', error);
      setSubmitError('Failed to create job. Please check your inputs and try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MainLayout>
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-black leading-tight tracking-[-0.033em] text-gray-900">
            Create New Job
          </h1>
          <p className="text-gray-600 mt-1">
            Fill in the details to create a new construction job
          </p>
        </div>

        {submitError && (
          <div className="mb-4 flex items-center gap-3 p-4 bg-red-50 border border-red-200 rounded-xl text-sm text-red-700">
            <span className="material-symbols-outlined text-base flex-shrink-0">error</span>
            <span className="flex-1">{submitError}</span>
            <button onClick={() => setSubmitError('')} className="text-red-400 hover:text-red-600 flex-shrink-0">
              <span className="material-symbols-outlined text-sm">close</span>
            </button>
          </div>
        )}

        {submitting && (
          <div className="mb-4 flex items-center gap-3 p-4 bg-blue-50 border border-blue-200 rounded-xl text-sm text-blue-700">
            <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin flex-shrink-0" />
            <span>Creating job…</span>
          </div>
        )}

        <JobForm onSubmit={handleSubmit} />
      </div>
    </MainLayout>
  );
};
